import React from 'react';

export default function AddFormButton({ onAdd }) {
  return <button type="button" className="ca-add-form-button" onClick={onAdd}>+ Add Form Fields</button>;
}